// removed by extract-text-webpack-plugin
module.exports = {"title":"Section__title___2ZwDP","subtitle":"Section__subtitle___15ncD","divider":"Section__divider___PGCL6","dividerLine":"Section__dividerLine___1PpZT"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/signUpMarketing/components/Section.scss
// module id = 1789
// module chunks = 0